<template>
  <div id="dropdown" class="closed">
    <div id="icon" class="icon" @click="toggleDropdown()">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
    </div>
    <div id="nav-menu">
      <nav>
        <ul>
          <li><router-link to="/" @click.native="toggleDropdown()">Home</router-link></li>
          <li><router-link to="/about" @click.native="toggleDropdown()">About</router-link></li>
          <li><router-link to="/pricing" @click.native="toggleDropdown()">Pricing</router-link></li>
          <li><router-link to="/gallery" @click.native="toggleDropdown()">Galleries</router-link></li>
          <li><router-link to="/contact" @click.native="toggleDropdown()">Contact</router-link></li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mobileNav',

  data () {
    return {
      expanded: false
    }
  },

  methods: {
    toggleDropdown () {
      this.expanded = !this.expanded
      document.getElementById('icon').classList.toggle('close')
      document.getElementById('nav-menu').classList.toggle('open')
    }
  }
}
</script>

<style scoped>
#dropdown {
  text-align: right;
  font-size: 24px;
  background-color: #00a7af
}

#nav-menu {
  max-height: 0;
  transition: max-height 0.25s ease-out;
  overflow: hidden;
}

#nav-menu.open {
  max-height: 500px;
  transition: max-height 0.25s ease-in;
}

.icon {
  display: inline-block;
  cursor: pointer;
  padding-right: 0.5em;
}

ul {
  list-style: none;
}

li {
  margin: 25px;
}

a {
  color: #fff;
  padding: 0.5em;
  border-style: none;
  border-width: thin;
  border-radius: 0.5em;
  text-decoration: none;
  transition: all 0.5s;
}

a:link, a:visited {
  color: #fff;
}

a:active, a:hover {
  background-color: #575f60;
  color: #ffffff;
  transition: all 0.5s;
}

.active {
  background-color: #575f60;
}

.colorNav {
  background-color: #575f60;
}

.bar1, .bar2, .bar3 {
  width: 35px;
  height: 5px;
  background-color: #fff;
  margin: 6px 0;
  transition: 0.4s;
}

/* Rotate first bar */
.close .bar1 {
  transform: rotate(315deg) translate(-9px, 6px);
}

/* Fade out the second bar */
.close .bar2 {
  opacity: 0;
  transform: rotate(450deg);
}

/* Rotate last bar */
.close .bar3 {
  transform: rotate(405deg) translate(-8px, -8px);
}
</style>



// WEBPACK FOOTER //
// src/components/MobileNavBar.vue